<template>
  <section class="bg_color">
    <h2>コラム記事</h2>
    <section class="inner">
      <div v-if="article" class="detail_wrap">
        <div class="detail_header">
          <div class="detail_author_img">
            <img :src="article.img" :alt="article.name" />
          </div>
          <div class="detail_header_info">
            <p class="detail_date">{{ article.date }}</p>
            <h3 class="detail_title">{{ article.title }}</h3>
          </div>
        </div>
        <hr class="detail_divider" />
        <div class="detail_body">
          <p class="detail_body_text">{{ article.body }}</p>
        </div>
        <div class="detail_footer">
          <router-link :to="{ name: 'ColumnList' }" class="btn_back"
            >一覧に戻る</router-link
          >
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import takahashi from "@/assets/images/column/takahsshi_s.png";
import oota from "@/assets/images/column/oota_s.png";
import nissiD from "@/assets/images/column/nissi_D_s.png";

const articles = [
  {
    id: "1",
    role: "ボートレース アナウンサー",
    name: "高橋アナさん",
    img: takahashi,
    date: "2026/02/20（金）",
    title: "皆様！！ボートレースを楽しんでいますか！！",
    body: [
      "その盛り上げに少しでも貢献したいと選手の調整にも実況演出の研究にも日々努力の高橋アナです。",
      "",
      "今回は２nd　TURNに向けて半年間使ってのモーターの現状を書いておきます。",
      "今年はエース機不在で乗り手の調整で出る出ないが激しくて本当に難しい年だと思います。",
      "",
      "40％以上で動きとイコールで確かな素性のモーターは　26、34、40、58、54、77は2連対ナンバーワンですが％ほどではないかも・・・",
      "60や63は％通りにコンスタントに動いています。",
      "",
      "％はあっても最初の頃に比べると下降線が　18、21、29、38ただこの4機も乗り手次第でポイントが加算出来るモーターだと思います。",
      "",
      "30％台も挽回逆転を狙えるモーター16、17、30、31、46、61、65、68、72",
      "",
      "上位モーターシリーズや低調機シリーズなど、％が真ん中あたりのモーターの使用回数が多いのも実情です。乗り手や抽選運にもかなり左右されますので、ゲーム感覚で楽しんでください♪♪",
    ].join("\n"),
  },
  {
    id: "2",
    role: "スポーツ報知",
    name: "太田記者さん",
    img: oota,
    date: "2026/04/05（日）",
    title: "SGボートレースクラシックは大盛況で幕を閉じました。",
    body: [
      "大一番は終わりましたが、まだまだ現行モーターは7月18日のGⅡモーターボート大賞まで12節も使用されます。",
      "",
      "クラシック終了時点での番付表です。矢印はクラシック前からの推移になります。",
      "",
      "【横綱】34→",
      "【大関】26→・54↘・77→",
      "【関脇】40→・46↗・72↗",
      "【小結】30→・37↑・63↑",
      "【前頭】20→・38→・49↗・60↓・76↓",
      "",
      "なお、新年度第1弾の4月5日(日)から温水パイプを取り外して実施されます",
    ].join("\n"),
  },
  {
    id: "3",
    role: "スポーツ報知",
    name: "太田記者さん",
    img: oota,
    date: "2026/02/20（金）",
    title: "SGクラシックのパンフレットが完成しました",
    body: [
      "地元の池田浩二、平本真之、磯部誠、前田滉選手のインタビューなど、盛りだくさんの内容です",
      "",
      "冊子(全20ページ)としての配布は3月4日頃になる見込みですが、WEBでも公開されます!!",
      "",
      "話がそれてしまいましたが、そこのモーターページで推した5機(34・77・40・26・76)プラス54・72の7機が「神セブン」でしょう。",
      "",
      "ただし、上位機ばかりを選んでしまうと、低勝率機節では「一つも出ていない」なんてことが生じてしまいます。",
      "",
      "そうならないためにも、2連対率25番目以下からも選びたいところです。",
      "",
      "2月16日終了時点で30位(33.9%)の【65号機】、37位(31.8%)の【46号機】、40位(31.0%)の【30号機】のいずれかを入れてみるのも楽しいかもしれません！",
    ].join("\n"),
  },
  {
    id: "4",
    role: "ガマステの看板D",
    name: "にっしーDさん",
    img: nissiD,
    date: "2026/02/20（金）",
    title: "はいどーも！にっしーです♪",
    body: [
      "1stが終わり、やれやれといったところですが…皆様の順位はどうでしたでしょうか？",
      "私はと言いますと…95位。可もなく不可もなくです(・∀・)",
      "",
      "すぐに2nd始まりますが…上位を狙うには少し勝負に出なくてはならないと思いまして、出来る限り参加する方と被らないようにする為、モーター勝率をやや無視して今回は魂の6機を選抜しました!!",
      "私のツートップは26号機&40号機！この2機は被る前提ですが、それ以外に33号機、34号機、54号機、そして蒲郡といえば年々何かと聞き覚えのある72号機！これです!!",
      "",
      "あとは運を天に任せましょう(^o^)ノ",
    ].join("\n"),
  },
  {
    id: "5",
    role: "ボートレース アナウンサー",
    name: "高橋アナさん",
    img: takahashi,
    date: "2026/05/01（金）",
    title: "ゴールデンウィーク直前のモーター状況",
    body: [
      "皆様！！ボートレースを楽しんでいますか！！",
      "その盛り上げに少しでも貢献したいと選手の調整にも実況演出の研究にも日々努力の高橋アナです。",
      "ゴールデンウィーク前に、現状のモーター状況のお復習いをしておきます。",
      "",
      "最上位は３４号機！！！抜けるモーターがない中でもこれがエース格でいいのでは。",
      "次に７２号機！！５４号機にも乗っている田路朋史選手が７２号機のほうが比較すると良さそうというジャッジをしています。ただ５４号機も双璧のパワーだと踏んでいます。この２機はペラがかなり止っていても回転が出ていると使った選手が話していたほどに本体底力があります。",
      "トップスリーとして挙げたかったもうひとつが２６号機です。近況特徴あるペラに叩き変えられいますが、乗れて次第ではハイパワーになります。",
      "％がまだ上昇してこないが、ＳＧでも噴き上げた４６号機や６１号機も確実に動くモーターです。",
      "私の厳選５機はここまでになります。",
      "",
      "",
      "１６号機、１７号機、３０号機、３８号機、４０号機、６０号機、６３号機、６５号機、７７号機、このあたりはコンスタントに出ているなという印象です。",
      "",
      "温水パイプが取れてからの推奨モーターなら７０号機！！出足ターン回り重視の選手が乗ればコーナー戦で威力がでます。",
      "復活傾向なら２１号機。降ろした頃の抜群モーターが紆余曲折をへて、再び輝きを取り戻しつつあります。",
      "そして復調ムードは５８号機、これも乗り手次第で再度覚醒しないのかと期待はしています。",
      "温水パイプが取れて馴染んで急変の予兆があるのが５９号機！！",
      "伸び特化で仕上げた時だけにクローズアップしたいのが２９号機！！！",
      "隠れ好素性で、ＳＧで峰選手が少しスパイスの整備を加えて更に良くなった３７号機。％の関係であまり使われてはいないが、もっと使えばファンの注目が集まるのになって思っています。",
      "",
      "乗り手の調整で相場は変化しますが、舟券作戦とともにＭＯＧ楽しんで欲しいものです。",
      "",
      "ＰＳ.近況のロットのペラが不発なのか、交換したモーターが軒並みダウンしています。そのあたりにも注意を払ってレース予想を楽しんでください！！！",
    ].join("\n"),
  },
  {
    id: "6",
    role: "スポーツ報知",
    name: "太田記者さん",
    img: oota,
    date: "2026/08/31（月）",
    title: "MOG2026〜27seasonに向けて①",
    body: [
      "いよいよ新シーズンが始まります。",
      "お盆開催からの3節がモーターの選定期間になっており、さっそく8月11日(火)〜16日(日)のお盆レースを振り返ります！",
      "",
      "使用されたモーターは11〜33号機、46〜67号機までの全45機。",
      "",
      "優勝した松竹大輔の14号機は、7月22日に実施されたモーター性能検査において、一番時計をマークしていました。",
      "前検から動きは良く、行き足中心に節イチ級でした。",
      "",
      "他では銘柄クラスが仕上げた印象。",
      "60号機の赤岩善生、31号機の磯部誠、16号機の黒野元基は、準優、優勝戦に入っても強めの気配でした。",
      "",
      "伸びに関しては52号機の河村了がキラリ。",
      "伏兵どころでは18号機の坪井爽佑でしょうか。",
      "",
      "前田滉は「今度（9/13〜）のルーキーシリーズでは、坪井選手のを引きたいですね。大きく調整をしていないのに、結構いいんですよ」と秘めたるポテンシャルを感じていました。",
    ].join("\n"),
  },
];

export default {
  name: "ColumnDetail",
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  computed: {
    article() {
      return articles.find((a) => a.id === this.id) || null;
    },
  },
};
</script>

<style lang="css" src="@/assets/css/style_parts.css" scoped></style>
<style lang="css" src="@/assets/css/style_column.css" scoped></style>
<style scoped>
.inner {
  background: #fff;
  box-shadow: 12px 10px 20px 0 rgba(25, 25, 25, 0.4);
  -webkit-box-shadow: 12px 10px 20px 0 rgba(25, 25, 25, 0.4);
}
.detail_body_text {
  white-space: pre-wrap;
}
</style>
